import { GenericStatus } from "./props";
import { faCheckCircle, faXmarkCircle, faClock } from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const OutcomePaymentStatus: GenericStatus[] = [
    {key: "requested", text: "Requested", icon: faClock as IconProp, tagVariant: 'warning'},
    {key: "completed", text: "Completed", icon: faCheckCircle as IconProp, tagVariant: 'success'},
    {key: "rejected", text: "Rejected", icon: faXmarkCircle as IconProp, tagVariant: 'error'}
]

export default OutcomePaymentStatus;